import axios from '@fs/zion-axios'

/**
 * The signed-in user's active Center Session. Rejects with 404 when the user has none.
 */
export const getCenterSessionForUser = () => axios.get('/service/discovery/incenterexperience/sessions/user')
